/*
* Log the customer in with their email and password.
*/
function login(email, password) {
  if ($('#customer_login .button').hasClass('disabled')){ return false; }
  $('#customer_login .button').addClass('disabled');
  $('.loginSignup .loader').show();
  $('#customer_login .error').hide();
  if (! isValidEmailAddress(email)){
    $('#customer_login .error').text('Email is invalid').show();
    return false;
  }
  var data = {
    'customer[email]': email,
    'customer[password]': password,
    form_type: 'customer_login',
    utf8: '✓'
  };
  

  var promise = $.ajax({
    url: '/account/login',
    method: 'post',
    data: data,
    dataType: 'html',
    async: true,
    success: function(response) {
      $('#customer_login .button').removeClass('disabled');
  	  $('.loginSignup .loader').hide();
      if (response.indexOf('Invalid login credentials') !== -1) {
        $('#customer_login .error').text('Invalid login credentials').show();
      } else if (response.indexOf('Too many attempts: Please try again in 10 minutes') !== -1) {
        $('#customer_login .error').text('Too many attempts: Please try again in 10 minutes').show();
      } else{
        $('#customer_login .error').hide();
         var checkoutUrl = getCheckoutUrl();
          if (checkoutUrl) {
            window.location.href = checkoutUrl;
          } else {
            // don't need to redirect, do what you like!
             window.location.reload();
          }
      }
    },
    error: function (xhr, ajaxOptions, thrownError) {
      $('#customer_login .button').removeClass('disabled');
  	  $('.loginSignup .loader').hide();
      console.log(xhr.status);
      $('#customer_login .error').text(thrownError).show;
    }
  });
  return promise;
}

/*
* Log the customer in with their email and password.
*/
function register(email, password, firstName, lastName) {
  if ($('#create_customern .button').hasClass('disabled')){ return false; }
  $('#create_customer .button').addClass('disabled');
  $('.loginSignup .loader').show();
  $('#create_customer .error').hide();
  var data = {
    'customer[email]': email,
    'customer[password]': password,
    'customer[first_name]': firstName,
    'customer[last_name]': lastName,
    form_type: 'create_customer',
    utf8: '✓'
  };
  
  if ( !email || !password || !firstName || !lastName){
     $('#create_customer .error').text('Please enter all fields').show();
     $('#create_customer .button').removeClass('disabled');
  	 $('.loginSignup .loader').hide();
    return false;
  }

  var promise = $.ajax({
    url: '/account',
    method: 'post',
    data: data,
    dataType: 'html',
    async: true,
    success: function(response){
      $('#create_customer .button').removeClass('disabled');
  	  $('.loginSignup .loader').hide();
      if (response.indexOf('email is invalid') !== -1) {
        $('#create_customer .error').text('Email is invalid').show();
      } else if (response.indexOf('email can&#39;t be blank') !== -1) { 
		$('#create_customer .error').text('email can&#39;t be blank').show();
      } else if (response.indexOf('password can&#39;t be blank.') !== -1) {
		$('#create_customer .error').text('password can&#39;t be blank').show();
      } else if (response.indexOf('Too many attempts: Please try again in 10 minutes') !== -1) {
        $('#create_customer .error').text('Too many attempts: Please try again in 10 minutes').show();
      } else if (response.indexOf('This email address is already associated with an account') !== -1) {
		$('#create_customer .error').text('This email address is already associated with an account. If this account is yours, you can reset your password.').show();
      } else {
        window.location = '/';
      }
    },
    error: function (xhr, ajaxOptions, thrownError) {
      $('#create_customer .button').removeClass('disabled');
  	  $('.loginSignup .loader').hide();
      console.log(xhr.status);
      $('#create_customer .error').text(thrownError).show();
    }
  });

  return promise;
}

/*
* Get the `checkout_url` from the URL query parameter, if it exists.
* (It only ever exists on the /account/login page)
*/
function getCheckoutUrl() {  
  function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }
  return getParameterByName('checkout_url');
}

function isValidEmailAddress(emailAddress) {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
};